<div
    class="min-h-screen w-full flex items-center justify-center p-4 bg-cover bg-center bg-no-repeat bg-[url('/Background.svg')]">

    <div class="bg-white w-full max-w-[500px] rounded-3xl shadow-lg p-10 md:p-12">

        <div class="flex items-center justify-center gap-3 mb-8">
            <img src="/logo.svg" alt="plandag logo" class="h-10" />
            <span class="text-4xl font-semibold tracking-tight text-[#00165A]">plandag</span>
        </div>

        <ng-container *ngIf="!isEmailSent; else successTemplate">
            <div class="text-center mb-8">
                <h1 class="text-3xl font-bold text-[#00165A] mb-2">{{ i18n.t('forgotYourPassword') }}</h1>
                <p class="text-sm text-slate-600">
                    {{ i18n.t('enterYourEmailAddressAndWeWillSendYou') }} <br>
                    {{ i18n.t('instructionsToResetYourPassword') }}
                </p>
            </div>

            <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
                <div class="mb-4">
                    <app-input [label]="i18n.t('email')" formControlName="email"
                        labelCustomClass="block mb-1 font-medium text-gray-700"
                        inputCustomClass="border border-gray-300 rounded-md px-3 h-[42px] w-full"
                        [submitted]="submitted">
                    </app-input>
                </div>

                <p-message *ngIf="showLimitWarning" severity="warn">{{ i18n.t('youHaveReachedTheEmailRequestLimit') }}</p-message>

                <div class="w-full mt-2">
                    <app-button [label]="i18n.t('continue')" type="submit" severity="info" customClass="w-full custom-dark-blue"
                        size="large" [loading]="loading">
                    </app-button>
                </div>

                <!-- Back to Login Link -->
                <div class="mt-6 text-center">
                    <a routerLink="/login"
                        class="text-sm font-medium text-[#00165A] hover:text-blue-700 hover:underline cursor-pointer transition-colors">
                        <i class="pi pi-arrow-left text-xs mr-1"></i> {{ i18n.t('backToLogin') }}
                    </a>
                </div>
            </form>
        </ng-container>

        <!-- Success/Confirmation Screen -->
        <ng-template #successTemplate>
            <div class="flex flex-col items-center justify-center text-center">
                <!-- Icon -->
                <div class="w-20 h-20 rounded-full border-2 border-green-600 flex items-center justify-center mb-6">
                    <i class="pi pi-envelope !text-4xl text-green-600"></i>
                </div>

                <h2 class="text-3xl font-semibold text-slate-700 mb-3">{{ i18n.t('checkYourEmail') }}</h2>

                <p class="text-slate-500 mb-8 max-w-[320px]">
                    {{ i18n.t('pleaseCheckTheEmailAddress') }} <br>
                    <span class="font-medium text-slate-700">{{ resetForm.get('email')?.value }}</span>
                    {{ i18n.t('forInstructionsToResetYourPassword') }}
                </p>

                <div class="w-full">
                    <p-message *ngIf="showLimitWarning" severity="warn">{{ i18n.t('youHaveReachedTheEmailRequestLimit') }}</p-message>

                    <p-message *ngIf="showSuccessMessage && !showLimitWarning" severity="success">
                        {{ i18n.t('aNewEmailHasBeenSentToYourInbox') }}
                    </p-message>
                    <app-button [label]="i18n.t('resendEmail')" type="button" (click)="resendEmail()" severity="info"
                        customClass="w-full custom-dark-blue mt-3" size="large" [loading]="loading">
                    </app-button>
                    <!-- <app-button (click)="resendEmail()" type="button"
                    class="w-full h-12 mt-3 border border-gray-300 rounded-md text-slate-700 font-medium hover:bg-gray-50 transition-colors">
                    Resend email
                </app-button> -->
                </div>
            </div>
        </ng-template>
    </div>
</div>
<p-toast />